import styled from 'styled-components';

export const Container = styled.div`
  .header {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    justify-content: space-between;

    .MuiTypography-root {
      margin-bottom: 0px;
    }
  }

  .form {
    padding-top: 10px;
  }

  .date-picker {
    .MuiOutlinedInput-root {
      background-color: #fff !important;
      border: 1px solid #c2c2c2;
    }
  }

  #dispensed-by {
    width: 100%;
    padding-right: 10px;
  }

  .section-title:nth-child(3) {
    margin-top: 30px;
  }
`;

export const SectionTitle = styled.p`
  font-size: 18px;
  color: #373737;
  font-weight: 500;
  margin-bottom: 16px;
`;
